module.exports = __webpack_public_path__ + "img/32.1ef196ad.webp";